import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChart2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M18.3346 18.958H1.66797C1.3263 18.958 1.04297 18.6747 1.04297 18.333C1.04297 17.9913 1.3263 17.708 1.66797 17.708H18.3346C18.6763 17.708 18.9596 17.9913 18.9596 18.333C18.9596 18.6747 18.6763 18.958 18.3346 18.958Z",
			fill: "#787878"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.875 18.9587H8.125C7.78333 18.9587 7.5 18.6753 7.5 18.3337V3.33366C7.5 1.90033 8.29167 1.04199 9.625 1.04199H10.375C11.7083 1.04199 12.5 1.90033 12.5 3.33366V18.3337C12.5 18.6753 12.2167 18.9587 11.875 18.9587ZM8.75 17.7087H11.25V3.33366C11.25 2.37533 10.8 2.29199 10.375 2.29199H9.625C9.2 2.29199 8.75 2.37533 8.75 3.33366V17.7087Z",
			fill: "#787878"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.83333 18.9587H2.5C2.15833 18.9587 1.875 18.6753 1.875 18.3337V8.33366C1.875 6.90033 2.60833 6.04199 3.83333 6.04199H4.5C5.725 6.04199 6.45833 6.90033 6.45833 8.33366V18.3337C6.45833 18.6753 6.175 18.9587 5.83333 18.9587ZM3.125 17.7087H5.20833V8.33366C5.20833 7.29199 4.75 7.29199 4.5 7.29199H3.83333C3.58333 7.29199 3.125 7.29199 3.125 8.33366V17.7087Z",
			fill: "#787878"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5013 18.958H14.168C13.8263 18.958 13.543 18.6747 13.543 18.333V12.4997C13.543 11.0663 14.2763 10.208 15.5013 10.208H16.168C17.393 10.208 18.1263 11.0663 18.1263 12.4997V18.333C18.1263 18.6747 17.843 18.958 17.5013 18.958ZM14.793 17.708H16.8763V12.4997C16.8763 11.458 16.418 11.458 16.168 11.458H15.5013C15.2513 11.458 14.793 11.458 14.793 12.4997V17.708Z",
			fill: "#787878"
		})
	]
});
export default SvgChart2;
